module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("au3lK"))).then(() => module.bundle.root('1iHdE'));